import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Perfil() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (!user) return (
    <div style={{ padding: 20 }}>
      <div style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 12, padding: 24, marginTop: 20, textAlign: 'center' }}>
        <div style={{ fontSize: 56, marginBottom: 12 }}>👤</div>
        <h2 style={{ marginBottom: 6 }}>Faça login</h2>
        <p style={{ color: 'var(--text2)', fontSize: 13, marginBottom: 20 }}>Entre para ver seus pedidos e pontos</p>
        <Link to="/login"><button className="btn-primary" style={{ marginBottom: 10 }}>Entrar →</button></Link>
        <Link to="/cadastro"><button className="btn-secondary">Criar conta grátis</button></Link>
      </div>
    </div>
  );

  const menus = [
    ['📦 Meus pedidos', () => navigate('/pedidos')],
    ['⭐ Meus pontos', () => navigate('/fidelidade')],
    ['📍 Endereço', () => {}],
    ['🔔 Notificações', () => {}],
    ...(user.is_admin ? [['⚙️ Painel Admin', () => navigate('/admin')]] : []),
  ];

  return (
    <div style={{ padding: 16 }}>
      <h2>👤 Meu Perfil</h2>

      {/* Card usuário */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 14, padding: 16, background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 12, marginBottom: 16 }}>
        <div style={{ width: 52, height: 52, borderRadius: '50%', background: 'linear-gradient(135deg,var(--red),var(--orange))', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 20, color: '#fff', flexShrink: 0 }}>
          {user.nome?.[0]?.toUpperCase()}
        </div>
        <div>
          <div style={{ fontSize: 16, fontWeight: 800 }}>{user.nome}</div>
          <div style={{ fontSize: 12, color: 'var(--text2)' }}>{user.email}</div>
          <div style={{ fontSize: 12, color: 'var(--orange)', marginTop: 2 }}>⭐ {user.pontos || 0} pontos</div>
        </div>
      </div>

      {/* Menu */}
      <div style={{ background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 12, overflow: 'hidden', marginBottom: 16 }}>
        {menus.map(([label, fn]) => (
          <div key={label} onClick={fn} style={{ padding: '14px 16px', borderBottom: '1px solid var(--border)', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 14, fontWeight: 600 }}
            onMouseOver={e => e.currentTarget.style.background = 'var(--bg4)'}
            onMouseOut={e => e.currentTarget.style.background = ''}>
            <span>{label}</span>
            <span style={{ color: 'var(--text3)' }}>→</span>
          </div>
        ))}
      </div>

      <button onClick={() => { logout(); navigate('/'); }} style={{ width: '100%', background: 'var(--bg3)', border: '1px solid var(--red)', color: 'var(--red)', padding: 12, borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 700, fontFamily: 'Nunito,sans-serif' }}>
        Sair da conta
      </button>
    </div>
  );
}
